module.exports = __webpack_public_path__ + "img/PENDING.c2b19cab.svg";